<template>
  <van-popup
    :value="visible"
    position="bottom"
    get-container="body"
    class="agr-select-popup"
  >
    <van-nav-bar title="添加农资" :border="false" left-arrow @click-left="$emit('update:visible', false)">
      <template #right>
        <van-icon name="filter-o" />
        <span class="primary-color" @click="popup.filter=true">筛选</span>
      </template>
    </van-nav-bar>
    <van-popup
      v-model="popup.filter"
      position="right"
      class="filter-popup"
      round
    >
      <van-search
        v-model="filterForm.search"
        label="搜索"
        placeholder="请输入搜索关键词"
      />
      <div class="agr-type">
        <div
          v-for="(value,key) in agrTypeOptions"
          :key="key"
          :class="{active:key===filterForm.agrType}"
          class="item"
          @click="filterForm.agrType=key"
        >
          {{ value.label }}
        </div>
      </div>
      <div class="confirm">
        <button class="reset-btn" @click="resetFilter">
          重置
        </button>
        <button class="confirm-btn" @click="confirmFiler">
          确定
        </button>
      </div>
    </van-popup>
    <wh-mobile-list
      :data-src="fetchUrl"
      :extra-params="extraParams"
      height="calc(100vh - 240px)"
    >
      <template #default="{list}">
        <table class="agr-table">
          <thead>
            <tr>
              <th>农资名称</th>
              <th>生产厂家</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i,index) in list" :key="index" @click="handleSelect(i)">
              <td class="name">
                {{ i|agrNameFilter }}
              </td>
              <td>{{ i|agrFactoryFilter }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </wh-mobile-list>
    <router-link :to="{name:'AgrCreate'}" class="create-btn">
      <span>+新增农资</span>
    </router-link>
  </van-popup>
</template>

<script>
import { agrTypeOptions } from '@/constant/common'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import { agrNameFilter, agrFactoryFilter } from '@/filter'

export default {
  name: 'AgrSelect',
  components: { WhMobileList },
  filters: {
    agrNameFilter, agrFactoryFilter
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      agrTypeOptions,
      popup: {
        filter: false
      },
      filterForm: {
        search: '',
        agrType: 'seed'
      },
      extraParams: {
        sort: '-id',
        search: undefined
      },
      fetchUrl: agrTypeOptions['seed'].findApi,
      fetchType: 'seed'
    }
  },
  methods: {
    resetFilter() {
      this.filterForm = {
        search: '',
        agrType: 'seed'
      }
    },
    confirmFiler() {
      this.extraParams.search = this.filterForm.search
      this.fetchType = this.filterForm.agrType
      this.fetchUrl = agrTypeOptions[this.filterForm.agrType].findApi
      this.popup.filter = false
    },
    handleSelect(val) {
      const result = {
        type: agrTypeOptions[this.fetchType].label,
        name: agrNameFilter(val),
        factory: agrFactoryFilter(val)
      }
      this.$emit('select', result)
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.primary-color {
  color: @primary-color;
}
.agr-select-popup {
  height: 100%;
  background: #F6F5F5;
}
.filter-popup {
  height: 100%;
  width: 80%;
  .agr-type {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    padding: 10px;
    > .item {
      padding: 8px 4px;
      text-align: center;
      border: 1px solid #F9F9F9;
      font-size: 12px;
      border-radius: 17px;
      background: #F9F9F9;
      &.active {
        border-color: @primary-color;
        background: rgba(32, 202, 160, .15);
        color: @primary-color;
      }
    }
  }
  .confirm {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    background: @primary-color;
    border: 1px solid @primary-color;
    border-radius: 40px;
    overflow: hidden;
    button {
      width: 50%;
      border: none;
      padding: 8px;
      font-size: 12px;
      &:active {
        filter: brightness(95%);
      }
    }
    .reset-btn {
      color: @primary-color;
      background: #fff;
      border-bottom-right-radius: 18px;
    }
    .confirm-btn {
      color: #fff;
      background: @primary-color;
    }
  }
}
.agr-table {
  width: 100%;
  text-align: center;
  background: #fff;
  tr:active {
    background: #efefef;
  }
  th {
    border-bottom: 1px solid #eee;
    font-size: 14px;
    font-weight: 400;
    color: @primary-color;
    padding: 10px;
  }
  td {
    color: #323332;
    font-size: 12px;
    padding: 10px;
  }
  .name {
    min-width: 125px;
  }
}
.create-btn {
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: @primary-color;
  font-size: 12px;
  border-top: 1px solid #efefef;
  background: #fff;
}
</style>
